
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi soigner son image de marque en ligne est essentiel",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez l'importance de soigner votre image de marque en ligne pour attirer, fidéliser vos clients et vous démarquer dans un environnement digital compétitif.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi soigner son image de marque en ligne ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Si soigner votre apparence fait toute la différence dans la “vraie vie”, votre identité digitale requiert, elle aussi, votre attention au travers de votre e-réputation.",
        },
      ],
    };
  },
};
